import {
  put,
  takeLatest,
  select,
  call,
  fork,
  join,
  all,
} from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as LandingAddonsSlice from "./LandingAddonsSlice";
import * as GlobalSlice from "../../../app/ducks/GlobalSlice";
import * as MarketplaceSlice from "../../Marketplace/ducks/MarketplaceSlice";
import * as selectors from "./selectors";
import Utils from "../../Checkout/ducks/utils";
import * as SiteAnalytics from "../../../sitecatalyst";
import { setAddToCartResponse } from "pages/Mobility/ducks/MobilitySlice";


function* getAddonFeatures(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    const globalData = yield select(selectors.globalData);
    const sessionCartData =
      globalData?.sessionCartData?.apiResponse?.prospectFlowData;

    const packages = sessionCartData?.cart?.packages ? Object.keys(sessionCartData?.cart?.packages)?.filter(
      (packageKey) =>
        sessionCartData?.cart?.packages[packageKey].packageType === "FOURG" || sessionCartData?.cart?.packages[packageKey].packageType === "FIVEG"
    ) : [];
    const packageKey = packages[0] || '';
    const requestBody = {
      cartMeta: {
        zipCode: sessionCartData?.cart?.zipCodeFromPlan || "",
        shoppingPath: "PROSPECT",
        flow: params?.payload?.flow,
        billingState: sessionCartData?.cart?.billingState || "",
        outletId: sessionCartData?.cart?.outletId || ""
      },
      packFeaturesAddon:
      {
        packageId: packageKey,
        deviceSku: sessionCartData?.cart?.packages[packageKey].deviceSku,
        simSku: sessionCartData?.cart?.packages[packageKey].simSku,
        contractLength: sessionCartData?.cart?.packages[packageKey].priceType,
        planId: sessionCartData?.cart?.packages[packageKey]?.plan?.pricePlanCode,
        packageType: params?.payload?.flow === "4g" ? "FOURG" : "FIVEG"
      }
    };
    const response = yield apiClient.post(
      API.GET_ADDON_FEATURES,
      requestBody
    );
    if (
      response &&
      response?.data?.serviceStatus?.success
    ) {
      yield put(LandingAddonsSlice.setAddonFeatures(response?.data?.featuresList || []));
      yield put(LandingAddonsSlice.setPremiumAddonFeatures(response?.data?.spoList || []));
    } else {
      throw Object.assign(
        new Error("Failed to get Addon features"),
        { status: response?.status, data: response?.data }
      );
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}

function* getAddOrManageFeatures(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    const requestBody = {
      cartMeta: {
        channel: params?.payload?.channel,
        ecpdId: params?.payload?.ecpdId,
        userId: params?.payload?.loginUserId,
        rootEcpdId: params?.payload?.rootEcpdId ?? "",
        shoppingPath: window?.mbtGlobal?.shoppingPath ?? params?.payload?.shoppingPath ?? "PROSPECT",
        zipCode: params?.payload?.zipCode
      },
    }

    const response = yield apiClient.post(
      API.GET_ADDOR_MANAGE_FEATURES,
      requestBody
    );
    //   const response ={data:
    //     {
    //     "serviceStatus": {
    //       "statusMessage": "Sucess",
    //       "statusCode": "200",
    //       "success": true,
    //       "bannerDetails": null
    //     },
    //     "showDeviceProtection": false,
    //     "showTechTeam": false,
    //     "featureList": null,
    //     "linesOnTransaction": null,
    //     "featureSummary": null,
    //     "featureGroup": [
    //       {
    //         "featureGroupName": "Additional Services",
    //         "featureGroupId": "2000006",
    //         "required": false,
    //         "mutuallyExclusive": false,
    //         "currentGroup": false,
    //         "position": 0,
    //         "featureList": [
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 2787,
    //             "featureRetailPrice": 75.0,
    //             "discountPercent": 0.0,
    //             "spo": true,
    //             "retrieveProductFlag": false,
    //             "featureName": "BI PRIORITY SETUP 5G - Expires After 1 Month",
    //             "minPrice": 75.0,
    //             "featureGroupId": "2000006",
    //             "spoMutexCategoryList": [],
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 2793,
    //             "featureRetailPrice": 75.0,
    //             "discountPercent": 0.0,
    //             "spo": true,
    //             "retrieveProductFlag": false,
    //             "featureName": "BI PRIORITY SETUP 4G - Expires After 1 Month",
    //             "minPrice": 75.0,
    //             "featureGroupId": "2000006",
    //             "spoMutexCategoryList": [],
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 2789,
    //             "featureRetailPrice": 5.0,
    //             "discountPercent": 0.0,
    //             "spo": true,
    //             "retrieveProductFlag": false,
    //             "featureName": "BI PRIORITY HELP DESK 5G",
    //             "minPrice": 5.0,
    //             "featureGroupId": "2000006",
    //             "spoMutexCategoryList": [],
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 2788,
    //             "featureRetailPrice": 5.0,
    //             "discountPercent": 0.0,
    //             "spo": true,
    //             "retrieveProductFlag": false,
    //             "featureName": "BI PRIORITY HELP DESK 4G",
    //             "minPrice": 5.0,
    //             "featureGroupId": "2000006",
    //             "spoMutexCategoryList": [],
    //             "enableOneTalkBlueJeansFeature": false
    //           }
    //         ]
    //       },
    //       {
    //         "featureGroupName": "Additional Services",
    //         "featureGroupDescription": "Choose from a range of free and paid apps and services to make the most out of your device.",
    //         "featureGroupId": "448",
    //         "required": false,
    //         "mutuallyExclusive": false,
    //         "currentGroup": false,
    //         "position": 0,
    //         "featureList": [
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 88041,
    //             "featureRetailPrice": 3.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Verizon Roadside Assistance",
    //             "minPrice": 3.0,
    //             "featureGroupId": "448",
    //             "enableOneTalkBlueJeansFeature": false
    //           }
    //         ]
    //       },
    //       {
    //         "featureGroupName": "Integrated Security Solutions - FWA",
    //         "featureGroupId": "2930003",
    //         "required": false,
    //         "mutuallyExclusive": true,
    //         "currentGroup": false,
    //         "position": 0,
    //         "featureList": [
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 90368,
    //             "featureRetailPrice": 30.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Trusted Connection Plus for FWA",
    //             "minPrice": 30.0,
    //             "featureDescription": "In addition to  the standard Trusted Connection SFO, Plus will support: General Apps Access Control, Private Apps Access Control, up to 8 Site To Site Tunnels, Modifiable Secure Access Capabilities, and Cloud Access Secure (CASB). One line/MTN (Mobile Telephone Number) with a FWA Trusted Connection Subscription SFO will give the customer the right to 5 concurrent connections between an Agent and the VSG. A 100% availability SLA will be supported for FWA lines using this SFO.",
    //             "featureGroupId": "2930003",
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 90367,
    //             "featureRetailPrice": 25.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Trusted Connection for FWA",
    //             "minPrice": 25.0,
    //             "featureDescription": "The FWA Trusted Connection SFO supports URL Filtering, Malware Protection, DNS Filtering, IP Filtering, Safe search, File filtering, up to 2 Site-toSite Tunnels, Limited Modifiable Secure Access Capabilities, LDAP/AD Integration and SAML/SSO. One line/MTN (Mobile Telephone Number) with a FWA Trusted Connection Subscription SFO gives the customer the right to up to 5 concurrent connections between an Agent and the VSG. A 100% availability SLA will be supported for FWA lines using this SFO.",
    //             "featureGroupId": "2930003",
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 90274,
    //             "featureRetailPrice": 20.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Verizon Business Internet Security Preferred",
    //             "minPrice": 20.0,
    //             "featureGroupId": "2930003",
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 90273,
    //             "featureRetailPrice": 10.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Verizon Business Internet Security Plus",
    //             "minPrice": 10.0,
    //             "featureGroupId": "2930003",
    //             "enableOneTalkBlueJeansFeature": false
    //           },
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 89976,
    //             "featureRetailPrice": 0.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Decline Enhanced Security",
    //             "minPrice": 0.0,
    //             "featureGroupId": "2930003",
    //             "enableOneTalkBlueJeansFeature": false
    //           }
    //         ]
    //       },
    //       {
    //         "featureGroupName": "IP Provisioning",
    //         "featureGroupDescription": "Manage public static, private static, or private dynamic IP addresses and more.",
    //         "featureGroupId": "488",
    //         "required": false,
    //         "mutuallyExclusive": true,
    //         "currentGroup": false,
    //         "position": 0,
    //         "featureList": [
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 90054,
    //             "featureRetailPrice": 4.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Static IPV4 4G FWA",
    //             "minPrice": 4.0,
    //             "featureDescription": "Static IPV4 4G FWA",
    //             "featureGroupId": "488",
    //             "enableOneTalkBlueJeansFeature": false
    //           }
    //         ]
    //       },
    //       {
    //         "featureGroupName": "IP Provisioning",
    //         "featureGroupDescription": "Manage public static, private static, or private dynamic IP addresses and more.",
    //         "featureGroupId": "5500003",
    //         "required": false,
    //         "mutuallyExclusive": true,
    //         "currentGroup": false,
    //         "position": 0,
    //         "featureList": [
    //           {
    //             "currentFeature": false,
    //             "mandateFeature": false,
    //             "availableFeature": true,
    //             "notApplicable": false,
    //             "globalFeature": false,
    //             "ipFeature": false,
    //             "volteFeature": false,
    //             "equipmentProtectionGroup": false,
    //             "tmpMdGroup": false,
    //             "billingCode": 85303,
    //             "featureRetailPrice": 0.0,
    //             "discountPercent": 0.0,
    //             "spo": false,
    //             "retrieveProductFlag": false,
    //             "featureName": "Static IPV6 4G",
    //             "minPrice": 0.0,
    //             "featureDescription": "Public Static IP allows the mobile device to maintain the same IP address every time it connects to the network. Public Static IP may be either unrestricted or restricted.",
    //             "featureGroupId": "5500003",
    //             "enableOneTalkBlueJeansFeature": false
    //           }
    //         ]
    //       }
    //     ],
    //     "mockResponse": false
    //   }
    // }
    if (
      response &&
      response?.data?.serviceStatus?.success
    ) {
      yield put(LandingAddonsSlice.setAddorManageFeatures(response?.data?.featureGroup || []));
    } else {
      throw Object.assign(
        new Error("Failed to get Addon features"),
        { status: response?.status, data: response?.data }
      );
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}

function* reserveIp(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {

    const response = yield apiClient.post(
      API.RESERVE_IP,
      params?.payload
    );

    if (
      response &&
      response?.data?.serviceStatus
    ) {
      yield put(LandingAddonsSlice.setReserveIpResp(response?.data));
      yield put(LandingAddonsSlice.setIpAddressDetails({ ipAddress: response?.data?.iPAddress || params?.payload?.ipAddress || "", restrictType: params?.payload?.restrictedUnrestricted }))
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}
function* updateManageFeatureAddonsToCart(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    const globalData = yield select(selectors.globalData);
    const sessionCartData =
      globalData?.sessionCartData?.apiResponse?.prospectFlowData;

    const packages = sessionCartData?.cart?.packages ? Object.keys(sessionCartData?.cart?.packages)?.filter(
      (packageKey) =>
        sessionCartData?.cart?.packages[packageKey].packageType === "FOURG" || sessionCartData?.cart?.packages[packageKey].packageType === "FIVEG"
    ) : [];
    const packageKey = packages[0] || '';
    const quantity = packages?.length || 1;
    const selectedPackageKey = params?.payload?.selectedPackageKey;
    let requestBody = {};
    requestBody = {
      cartMeta: {
        zipCode: sessionCartData?.prospect5gLoopQualAddress?.zipCode || "",
        shoppingPath: "PROSPECT",
        flow: params?.payload?.flow,
        userId: globalData?.widgetInputParams?.mbloginid?.value ? globalData?.widgetInputParams?.mbloginid?.value : window?.mbtGlobal?.userId,
        sourceSystem: globalData?.widgetInputParams?.sourcesystem?.value ?? globalData?.widgetInputParams?.target?.value ?? window?.mbtGlobal?.sourceSystem ?? "",
        ecpdId: globalData?.widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId,
        email: globalData?.widgetInputParams?.mbauseremail?.value ?? window?.mbtGlobal?.userEmail,
        clientId: globalData?.widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientName ?? "",
        cpqCartId: globalData?.cartId,
        cpqCartVersionId: globalData?.cpqCartVersionId
      },
      lines: [
        {
          packageId: selectedPackageKey,
          packageType: sessionCartData?.cart?.packages[selectedPackageKey]["packageType"],
          // packageId: packageKey,
          //   packageType: params?.payload?.flow === "4g" ? "FOURG" : "FIVEG",
          operation:
            params?.payload?.flow === "4g" ? "UPDATEBULKQTY" : "UPDATE",
          features: params?.payload?.features || [],
          quantity: quantity,
        }]




    };
    window.sessionStorage.setItem('addOnCartData', JSON.stringify({ productDetail: requestBody?.lines[0]?.features, requestPayload: requestBody }))
    //manage features add or update call
    const isMixedCart = yield select(state => state?.GlobalData?.sessionCartData?.isMixedCart)
    if (isMixedCart) requestBody = { ...requestBody, "allowMixedCart": true }
    const response = yield apiClient.post(
      API.MOBILITY_ADD_TO_CART,
      requestBody
    );
    let sessionCartResponse = {
      prospectFlowData: response?.data?.response,
      serviceStatus: response?.data?.status,
    };
    if (
      response &&
      response?.data?.status?.success &&
      response?.data?.response
    ) {
      yield put(MarketplaceSlice.setAddToCartResponse(response?.data));
      yield put(LandingAddonsSlice.setAddonCartResp(response?.data));
      const newStore = Utils.setStoreFromRetrieve(sessionCartResponse);
      yield put(GlobalSlice.setSessionCartData(newStore));
      window?.localStorage?.setItem("_cartData", JSON.stringify(newStore));
    } else {
      yield put(LandingAddonsSlice.setAddonCartResp(response?.data));
      yield put(MarketplaceSlice.setAddToCartResponse(response?.data));
      throw Object.assign(
        new Error("Failed to update Addon selection in session cart"),
        { status: response?.status, data: response?.data }
      );
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}
function* updateAddonsToCart(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    const globalData = yield select(selectors.globalData);
    const sessionCartData =
      globalData?.sessionCartData?.apiResponse?.prospectFlowData;

    const packages = sessionCartData?.cart?.packages ? Object.keys(sessionCartData?.cart?.packages)?.filter(
      (packageKey) =>
        sessionCartData?.cart?.packages[packageKey].packageType === "FOURG" || sessionCartData?.cart?.packages[packageKey].packageType === "FIVEG"
    ) : [];
    const packageKey = packages[0] || '';
    const selectedPackageKey = params?.payload?.selectedPackageKey;
    const quantity = 1;
    let requestBody = {};
    requestBody = {
      cartMeta: {
        zipCode: sessionCartData?.prospect5gLoopQualAddress?.zipCode || "",
        shoppingPath: "PROSPECT",
        flow: params?.payload?.flow,
        cpqCartId: globalData?.cartId,
        cpqCartVersionId: globalData?.cpqCartVersionId
      },
      lines: packages.length > 1 && !selectedPackageKey ? packages.map((packageKey) => {
        return {
          packageId: packageKey,
          packageType: params?.payload?.flow === "4g" ? "FOURG" : "FIVEG",
          operation:
            params?.payload?.flow === "4g" ? "UPDATEBULKQTY" : "UPDATE",
          features: params?.payload?.features || [],
          quantity: quantity,
        }
      }) : [
        {
          packageId: packageKey,
          packageType: params?.payload?.flow === "4g" ? "FOURG" : "FIVEG",
          operation:
            params?.payload?.flow === "4g" ? "UPDATEBULKQTY" : "UPDATE",
          features: params?.payload?.features || [],
          quantity: quantity,
        },
      ],
    };
    window.sessionStorage.setItem('addOnCartData', JSON.stringify({ productDetail: requestBody?.lines[0]?.features, requestPayload: requestBody }))

    const isMixedCart = yield select(state => state?.GlobalData?.sessionCartData?.isMixedCart)
    if (isMixedCart) requestBody = { ...requestBody, "allowMixedCart": true }
    const response = yield apiClient.post(
      API.MOBILITY_ADD_TO_CART,
      requestBody
    );
    let sessionCartResponse = {
      prospectFlowData: response?.data?.response,
      serviceStatus: response?.data?.status,
    };
    if (
      response &&
      response?.data?.status?.success &&
      response?.data?.response
    ) {
      yield put(setAddToCartResponse(response?.data));
      const newStore = Utils.setStoreFromRetrieve(sessionCartResponse);
      yield put(GlobalSlice.setSessionCartData(newStore));
      window?.localStorage?.setItem("_cartData", JSON.stringify(newStore));
      SiteAnalytics.eventAddtocartTracking('Add To Cart', newStore, '4g5g', 'addOnInfo');
    } else {
      yield put(setAddToCartResponse(response?.data));
      throw Object.assign(
        new Error("Failed to update Addon selection in session cart"),
        { status: response?.status, data: response?.data }
      );
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
    if (params.payload.callBackFn) params?.payload?.callBackFn()
  }
}


function* updateAddToCartBackUp(params) {
  yield put(LandingAddonsSlice.setAPIError(false));
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    let requestBody = {};
    requestBody = params.payload;
    requestBody.cartMeta = {
      ...requestBody.cartMeta,
      cpqCartId: globalData?.cartId,
      cpqCartVersionId: globalData?.cpqCartVersionId
    }
    const response = yield apiClient.post(
      API.MOBILITY_ADD_TO_CART,
      requestBody
    );
    let sessionCartResponse = {
      prospectFlowData: response?.data?.response,
      serviceStatus: response?.data?.status,
    };
    if (
      response &&
      response?.data?.status?.success &&
      response?.data?.response
    ) {
      yield put(MarketplaceSlice.setAddToCartResponse(response?.data));
      const newStore = Utils.setStoreFromRetrieve(sessionCartResponse);
      yield put(GlobalSlice.setSessionCartData(newStore));
      window?.localStorage?.setItem("_cartData", JSON.stringify(newStore));
    } else {
      yield put(MarketplaceSlice.setAddToCartResponse(response?.data));
      throw Object.assign(
        new Error("Failed to update Addon selection in session cart"),
        { status: response?.status, data: response?.data }
      );
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}



function* getBackUpPlans() {
  yield put(LandingAddonsSlice.setLandingAddonsPageLoading(true));
  try {
    const requestBody = {
      cartMeta: {
        shoppingPath: "PROSPECT",
        flow: "4g",
        qualified4GHome: false,
      },
    };
    const resp = yield apiClient.post(API.GET_4G_PLAN, requestBody);
    if (resp?.data) {
      yield put(LandingAddonsSlice.setBackUpPlansDetails(resp?.data));
    } else {
      yield put(LandingAddonsSlice.setBackUpPlansDetails([]));
    }
  } catch (err) {
    yield put(LandingAddonsSlice.setAPIError(true));
  } finally {
    yield put(LandingAddonsSlice.setLandingAddonsPageLoading(false));
  }
}

export default function* actionWatcher() {
  yield takeLatest(LandingAddonsSlice.updateAddonToCart.type, updateAddonsToCart);
  yield takeLatest(LandingAddonsSlice.updateManageFeatureAddonToCart.type, updateManageFeatureAddonsToCart);
  yield takeLatest(LandingAddonsSlice.getAddonFeatures.type, getAddonFeatures);
  yield takeLatest(LandingAddonsSlice.getAddOrManageFeatures.type, getAddOrManageFeatures);
  yield takeLatest(LandingAddonsSlice.addToCartBackUp.type, updateAddToCartBackUp);
  yield takeLatest(LandingAddonsSlice.getBackUpPlans.type, getBackUpPlans);
  yield takeLatest(LandingAddonsSlice.reserveIp.type, reserveIp);
}
